import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsSCFJourneySelected } from "@shared/v2/lib/getIsSCFJourneySelected";

export const useIsSCFJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsSCFJourneySelected(financeSimulation.journey);
};
